import { Box, Button, HStack, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { useSteps } from "./provider";

const StepButton = ({
  disabled,
  btn,
  currentStep,
  current,
  onClick,
  label,
  last,
  type,
  hasLabel = true,
}) => {
  const getButtonStyles = () => {
    const map = {
      default: {},
      bullet: {
        p: "0 !important",
      },
    };

    return map[type ?? "default"];
  };

  const getLabelStyles = () => {
    const map = {
      default: {},
      bullet: {
        mb: "18px !important",
        color: current ? "#4E4B66" : "#A0A3BD",
        fontWeight: "600",
      },
    };

    return map[type ?? "default"];
  };

  const getButtonSizes = () => {
    const map = {
      default: ["32px", "40px"],
      bullet: "12px",
    };
    return map[type ?? "default"];
  };

  const getGaps = () => {
    const map = {
      default: last ? 0 : ["60px", "110px", "140px"],
      bullet: last ? 0 : "74px",
    };
    return map[type ?? "default"];
  };

  const getLineWidths = () => {
    const map = {
      default: ["120px", "160px", "198px"],
      bullet: "110px",
    };

    return map[type ?? "default"];
  };

  const getContainerStyles = () => {
    const map = {
      default: {
        flexDir: "column",
      },
      bullet: {
        flexDir: "column-reverse",
      },
    };

    return map[type ?? "default"];
  };

  const getButtonText = () => {
    const map = {
      default: btn,
      bullet: "",
    };

    return map[type ?? "default"];
  };

  const getCurrentColor = () =>
    currentStep > 0 || current ? "#06c344" : "#e5e5e58f";
  return (
    <HStack
      ml="0 !important"
      sx={{
        "--buttonSize": getButtonSizes(),
        "--gap": getGaps(),
        "--lineWidth": getLineWidths(),
      }}
    >
      <VStack
        w="fit-content"
        mr="var(--gap)"
        pos="relative"
        zIndex={99}
        {...getContainerStyles()}
      >
        <Button
          pos="relative"
          // disabled={disabled}
          pointerEvents={disabled ? "none" : "unset"}
          opacity={disabled ? [0.8, 0.4] : 1}
          // bg={current ? "#06c344" : "#e5e5e58f"}
          bg={getCurrentColor()}
          backdropFilter={"blur(10px) opacity(0.1)"}
          border={"1px solid transparent"}
          borderColor={getCurrentColor()}
          // boxSize={["32px", "40px"]}
          minW={"var(--buttonSize)"}
          boxSize={"var(--buttonSize)"}
          fontSize={"sm"}
          color={current ? "white" : "#4E4B66"}
          borderRadius={"full"}
          onClick={onClick}
          // aria-label="step1"
          zIndex={1}
          _focus={{
            borderColor: "#06c344",
            shadow: "0 0 0 3px #06c34491",
          }}
          _before={{
            content: "''",
            pos: "absolute",
            // w: ["110px", "200px"],
            w: "var(--lineWidth)",
            h: "2px",
            // bg: disabled ? "#D9DBE95f" : "#D9DBE9",
            bg: getCurrentColor(),
            left: "calc(var(--buttonSize, 40px))",
            d: last ? "none" : "block",
            zIndex: -1,
          }}
          {...getButtonStyles()}
        >
          {getButtonText()}
        </Button>
        {label && (
          <Text
            textAlign="center"
            fontSize={["sm", "md"]}
            {...getLabelStyles()}
          >
            {label}
          </Text>
        )}
      </VStack>
      {/* {!last && (
        <Box
          flex="1"
          minW="200px"
          h="2px"
          bg="#D9DBE9"
          pos="relative"
          top={[
            "calc(((32px - 6px) / 2) * -1)",
            "calc(((40px - 6px) / 2) * -1)",
          ]}
        ></Box> */}
      {/* )} */}
    </HStack>
  );
};

export const StepContent = ({ children, ...xprops }) => {
  return <Box {...xprops}>{children}</Box>;
};

StepContent.displayName = "StepContent";

export const StepButtons = ({ steps, currentStep, setStep, _styles, type }) => {
  const maxStep = steps?.length;
  return (
    <HStack alignItems="flex-start" {..._styles}>
      {steps?.map(({ label, btn }, i) => (
        <StepButton
          key={i}
          btn={btn ?? i + 1}
          disabled={currentStep < i}
          currentStep={currentStep}
          current={i === currentStep}
          onClick={() => setStep(i)}
          label={label}
          last={i === maxStep - 1}
          type={type}
        />
      ))}
    </HStack>
  );
};

const Steps = ({ children, steps, _btnContainer, type, ...xprops }) => {
  const context = useSteps();

  const { currentStep, setStep } = context;

  // console.log("STEPS CONTEXT", context);

  const handleCurrentStep = (currentStep) => {
    setStep(currentStep);
  };

  const renderStep = () => {
    return React.Children.map(children, (child, index) => {
      if (!React.isValidElement(child)) return;

      // console.log("CHILD NAME", child.type.displayName);
      if (
        child.type.name === "StepContent" || // doesn't work in production
        child.type.displayName === "StepContent" // works in production
      ) {
        return child.props.children[currentStep];
      }
      return child;
    });
  };

  const getContentProps = () => {
    return React.Children.map(children, (child, index) => {
      if (!React.isValidElement(child)) return;

      if (
        child.type.name === "StepContent" || // doesn't work in production
        child.type.displayName === "StepContent" // works in production
      ) {
        const { children: _, ...props } = child.props;
        return props;
      }
      return {};
    })[0];
  };

  return (
    <Box {...xprops}>
      <StepButtons
        currentStep={currentStep}
        steps={steps}
        setStep={handleCurrentStep}
        _styles={_btnContainer}
        type={type}
      />

      <Box mt="20px" {...getContentProps()}>
        {renderStep()}
      </Box>
    </Box>
    // </StepsProvider>
  );
};

export default Steps;
